module.exports = __webpack_public_path__ + "static/media/observador.83f237d6.webp";